// src/store/slices/finalExamSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUrl } from "../constant/apiUrl";

export const fetchFinalExam = createAsyncThunk(
  "finalExam/fetchFinalExam",
  async ({ page = 1} = {}, thunkAPI) => {
    try {
      const params = new URLSearchParams();
    const state = thunkAPI.getState() ;
    const token = state.auth?.access_token;

      // أضف كل القيم التي لها قيمة حقيقية فقط


      const response = await axios.get(
        `${apiUrl}/courses/1/final-exam/questions`,
          {
          headers: token ? { Authorization: `Bearer ${token}` } : {}, // Add token only if exists
        }
      );

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);
// إضافة عقار جديد مع التوكن
export const addfinalExam = createAsyncThunk(
  "finalExam/addFinalExam",
async (formData, thunkAPI) => {
  try {
    const state = thunkAPI.getState();
    const token = state.auth;
console.log(token,"token");

    // const formData = new FormData();
    // formData.append("title", title);
    // formData.append("description", description);

    // // Append each image
    // image.forEach((image, index) => {
    //   formData.append(`images[${index}]`, image.file); // send the actual File object
    // });


const response = await axios.post(
      "https://nanosoft.technology/blue-nile/api/finalExam",formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    thunkAPI.dispatch(fetchFinalExam());
    return response.data;
  } catch (error) {
          console.log(error);

    return thunkAPI.rejectWithValue(      
      error.response?.data?.errors
        ? Object.values(error.response.data.errors)[0][0]
        : "حدث خطأ أثناء إضافة العقار"
    );
  }
}

);
const finalExamSlice = createSlice({
  name: "finalExam",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFinalExam.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFinalExam.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchFinalExam.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
                      .addCase(addfinalExam.pending, (state) => {
                state.loading = true;
                state.error = null;
              })
              .addCase(addfinalExam.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
              })
              .addCase(addfinalExam.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
              })
  },
});

export default finalExamSlice.reducer;
